import request from '../request'

export default {
  getUsuario: function () {
    return request.get('usuario')
  },
  addUsuario: function (data) {
    return request.post('usuario', data)
  },
  updateUsuario: function (data) {
    return request.put(`usuario/${data.ID_USUARIO}`, data)
  },
  deleteUsuario: function (idUsuario) {
    return request.delete(`usuario/${idUsuario}`)
  },
  getRoles: function () {
    return request.get('roles')
  }
}
